export default __webpack_public_path__ + "images/3d8e859651817e5a787344abc76cef41-climbing.webp";